/**
 * components/settings/StampPreview.tsx
 *
 * Rendu SVG d'un tampon circulaire d'avocat.
 * Délègue entièrement la génération du SVG à stampSvgGenerator.ts,
 * source unique de vérité partagée avec pdfDossierBuilder.ts.
 * Garantit que l'aperçu et le tampon imprimé dans le dossier PDF
 * sont visuellement identiques.
 *
 * Updated: refactored to use generateStampSvg() from stampSvgGenerator.ts.
 */

import { useId } from 'react';
import { generateStampSvg } from '../../utils/stampSvgGenerator';

interface StampPreviewProps {
  title: string;
  toqueNumber: string;
  size?: number;
  pieceNumber?: number;
}

export default function StampPreview({ title, toqueNumber, size = 160, pieceNumber }: StampPreviewProps) {
  const uid = useId().replace(/:/g, '');

  const svgMarkup = generateStampSvg({
    title,
    toqueNumber,
    pieceNumber,
    uniqueId: uid,
    width: size,
    height: size,
  });

  return (
    <div
      style={{ width: size, height: size, display: 'inline-block', flexShrink: 0 }}
      dangerouslySetInnerHTML={{ __html: svgMarkup }}
    />
  );
}
